import { render, staticRenderFns } from "./OrderAIGCS.vue?vue&type=template&id=dfaa8f00&scoped=true&"
import script from "./OrderAIGCS.vue?vue&type=script&lang=js&"
export * from "./OrderAIGCS.vue?vue&type=script&lang=js&"
import style0 from "./OrderAIGCS.vue?vue&type=style&index=0&id=dfaa8f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaa8f00",
  null
  
)

export default component.exports